import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';
import { type DrawerPanel } from '@canvas/model/sidebar-panel';
import { currentDrawerPanel } from '@canvas/sidebar-panel-state';

export const initializeConfluencePanelListeners = () => {
  waitForContentAPI().then((contentAPI) => {
    contentAPI.confluenceAPI?.sidebar?.onConfluenceSidebarStateChange?.(
      ({ isOpen, panelId }) => {
        if (!isOpen) {
          currentDrawerPanel.panel = 'none';
          return;
        }

        //we care only about comments and details panels
        if (!panelId || !['detailsPanel', 'commentsPanel'].includes(panelId)) {
          currentDrawerPanel.panel = 'none';
          return;
        }

        currentDrawerPanel.panel = panelId as DrawerPanel;
      }
    );
  });
};
